'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthPoliciesListPage, IDP_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/idp/_layout/policies/')({
  component: () => <AuthPoliciesListPage paths={IDP_AUTH_POLICY_PATHS} />
});